import * as React from "react"

import { isNumber } from "../../../../../../util/Strings"

import UnavailableLink from "../UnavailableLink"

import CreateChildItem from "./CreateChildItem"
import ItemInCollection from "./ItemInCollection"
import Item from "./Item"
import DeleteItem from "./DeleteItem"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    linkParameters: string[]
}

export const ItemInternalLink = ({
    attributes,
    customLabel,
    label,
    linkParameters,
}: Props): JSX.Element => {
    if (linkParameters.length === 2 && isNumber(linkParameters[1])) {
        // ITEM.[ITEMID] => OPENS THE GIVEN ITEM DETAIL PAGE IN ITS LIST
        return (
            <Item
                attributes={attributes}
                customLabel={customLabel}
                itemId={parseInt(linkParameters[1])}
                label={label}
            />
        )
    } else if (linkParameters.length === 3) {
        if (isNumber(linkParameters[1]) && isNumber(linkParameters[2])) {
            // ITEM.[SMARTLISTID].[ITEMID] => OPENS THE GIVEN ITEM DETAIL PAGE IN A GIVEN SMARTLIST
            return (
                <ItemInCollection
                    attributes={attributes}
                    collectionId={parseInt(linkParameters[1])}
                    customLabel={customLabel}
                    itemId={parseInt(linkParameters[2])}
                    label={label}
                />
            )
        } else if (
            linkParameters[1] === "create" &&
            isNumber(linkParameters[2])
        ) {
            // ITEM.CREATE.[ITEMID] => CREATE CHILD ITEM FOR THE GIVEN ITEM
            return (
                <CreateChildItem
                    attributes={attributes}
                    label={label}
                    itemId={parseInt(linkParameters[2])}
                />
            )
        } else if (
            linkParameters[1] === "delete" &&
            isNumber(linkParameters[2])
        ) {
            // ITEM.DELETE.[ITEMID] => DELETES THE GIVEN ITEM
            return (
                <DeleteItem
                    attributes={attributes}
                    label={label}
                    itemId={parseInt(linkParameters[2])}
                />
            )
        }
    } else if (linkParameters.length === 4) {
        if (
            linkParameters[1] === "create" &&
            isNumber(linkParameters[2]) &&
            isNumber(linkParameters[3])
        ) {
            // ITEM.CREATE.[ITEMID].[CHILDLISTID] =>
            // CREATE CHILD ITEM FOR THE GIVEN ITEM
            // WITHIN THE GIVEN CHILD LIST
            return (
                <CreateChildItem
                    attributes={attributes}
                    label={label}
                    itemId={parseInt(linkParameters[2])}
                    childConceptId={parseInt(linkParameters[3])}
                />
            )
        }
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default ItemInternalLink
